import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useApplicantStore from '../applicantStore/useApplicantStore';
import {
  coapplicantStore,
  keysToPersist,
} from '../coapplicantStore/coapplicantStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useWorkflowStore from '../workflowStore/useWorkflowStore';
import { CoapplicantState } from './types/CoapplicantState';

const useCoapplicantStore: Store<CoapplicantState> = createStore({
  creator: coapplicantStore({
    useApiStore: lazyDependency(() => useApiStore),
    useApplicantStore: lazyDependency(() => useApplicantStore),
    useDashboardStore: lazyDependency(() => useDashboardStore),
    useWorkflowStore: lazyDependency(() => useWorkflowStore),
  }),
  id: 'coapplicant',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
  persistHMR: true,
});

export default useCoapplicantStore;
